import React from 'react';
import { useTranslation } from 'react-i18next';
import CardInfo from './CardInfo';

function fmtPct(v) {
    if (v == null || isNaN(v)) return '—';
    const n = Number(v);
    return `${n >= 0 ? '+' : ''}${n.toFixed(1)}%`;
}

export default function PerformanceGaps({ gaps }) {
    const { t } = useTranslation();

    const headline = gaps?.lflGrowthPct;
    const under = Array.isArray(gaps?.underperformers) ? gaps.underperformers : [];
    const over  = Array.isArray(gaps?.overperformers) ? gaps.overperformers : [];

    return (
        <div className="v3-card v3-cc-card">
            <div className="v3-cc-card-header-row">
                <h3>{t('Performance Gaps')}</h3>
                <CardInfo title={t('About Performance Gaps')}>
                    <p>
                        {t('This card shows')} <strong>{t('Like-for-Like (LFL) growth')}</strong> — {t('a year-over-year comparison of sales for tenants that were active in both the current and prior period.')}
                    </p>
                    <p>
                        <strong>{t('Headline number')}</strong> {t('is the average LFL growth across all eligible tenants.')}
                    </p>
                    <p>
                        <strong>{t("How it's calculated")}:</strong> {t('For each tenant, growth = ((current quarter sales − same quarter last year) / same quarter last year) × 100.')}
                    </p>
                    <p>
                        <strong>{t('Overperformers')}</strong> {t('are the top 5 tenants with highest growth.')}
                        <br />
                        <strong>{t('Underperformers')}</strong> {t('are the bottom 5 with lowest growth.')}
                    </p>
                    <p>
                        {t('Only tenants that were live before the comparison period started and had sales in both periods are included — new stores are excluded.')}
                    </p>
                </CardInfo>
            </div>

            <div className="v3-cc-gaps-headline" style={{
                color: headline >= 0 ? 'var(--v3-green)' : 'var(--v3-red)',
            }}>
                {t('LFL growth')}: {fmtPct(headline)}
            </div>
            <div className="v3-cc-gaps-cols">
                <div className="v3-cc-gaps-col">
                    <h4>{t('Underperformers')}</h4>
                    {under.length === 0 ? (
                        <div className="v3-text-muted" style={{ fontSize: 12 }}>{t('None.')}</div>
                    ) : (
                        <ul>
                            {under.map((t) => (
                                <li key={t.tenant_id}>
                                    <span className="name">{t.name || '—'}</span>
                                    <span className="v3-cc-trend-down">{fmtPct(t.lfl_pct)}</span>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
                <div className="v3-cc-gaps-col">
                    <h4>{t('Overperformers')}</h4>
                    {over.length === 0 ? (
                        <div className="v3-text-muted" style={{ fontSize: 12 }}>{t('None.')}</div>
                    ) : (
                        <ul>
                            {over.map((t) => (
                                <li key={t.tenant_id}>
                                    <span className="name">{t.name || '—'}</span>
                                    <span className="v3-cc-trend-up">{fmtPct(t.lfl_pct)}</span>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
}
